export default "__VITE_ASSET__CoVAp3H1__"